const getColor = (index, min, max) => {
  if (index <= min) return 'var(--secondary-color)';
  if (index > min && index <= max) return 'var(--purple-color)';
  return 'var(--grey-2-color)';
};


const PriceIndicator = ({ min_price_category, max_price_category }) => {
  // Ensure the values are cast to numbers
  const minPrice = Number(min_price_category);
  const maxPrice = Number(max_price_category);

  return (
    <div>
      {[...Array(5)].map((_, index) => (
        <span
          key={index}
          style={{
            color: getColor(index, minPrice, maxPrice),
            fontSize: '1.8rem',
            marginRight: '2px'
          }}
        >
          £
        </span>
      ))}
    </div>
  );
};

export default PriceIndicator;


